import type { ApiDailyRewardGrant } from "@bridge-applications/pb-types";
import type { TFunction } from "i18next";
import energySound from "../../assets/static/audio/slot-machine-splash-sound-2.mp3";
import coinSound from "../../assets/static/audio/slot-machine-coins-falling.mp3";
import energy from "../../assets/static/images/symbols/v1/symbol-energy-drink.webp";
import beachCoins from "../../assets/static/images/coins/style1/coin-style1__beach-coin.webp";
import gram from "../../assets/static/images/coins/style1/coin-style1__gram.webp";
import notcoin from "../../assets/static/images/coins/style1/coin-style1__not.webp";
import usdt from "../../assets/static/images/coins/style1/coin-style1__usdt.webp";
import type { RewardCollectionPresentation } from "./rewardCollection";

const CURRENCY_IMAGES: Readonly<Record<string, string>> = {
    BEACH_COINS: beachCoins,
    GRAM: gram,
    NOT: notcoin,
    USDT: usdt,
};

/** One cue per reward category, even when a bundle contains several currencies. */
export function dailyRewardSounds(
    grants: readonly ApiDailyRewardGrant[],
): string[] {
    const sounds: string[] = [];
    if (grants.some((grant) => grant.kind === "SM_ENERGY"))
        sounds.push(energySound);
    if (grants.some((grant) => grant.kind !== "SM_ENERGY"))
        sounds.push(coinSound);
    return sounds;
}

/** Present the confirmed grants, preserving the server's amounts and scales. */
export function dailyRewardCollection(
    grants: readonly ApiDailyRewardGrant[],
    t: TFunction,
): RewardCollectionPresentation | null {
    const firstGrant = grants[0];
    if (!firstGrant) return null;

    return {
        id: firstGrant.grantId,
        rewards: grants.map((grant) => ({
            id: grant.grantId,
            amount: grant.amount,
            decimalScale: grant.kind === "CURRENCY" ? grant.decimalScale : 0,
            label:
                grant.kind === "SM_ENERGY"
                    ? t("holyWheel.prizeNames.energy")
                    : grant.currencyCode === "BEACH_COINS"
                      ? t("holyWheel.prizeNames.beach-coins")
                      : grant.currencyCode,
            imageUrl:
                grant.kind === "SM_ENERGY"
                    ? energy
                    : CURRENCY_IMAGES[grant.currencyCode],
        })),
    };
}
